export const hasClassName = (element, targetClassNames) => {
  const {classList} = element;
  const matchesClassNameInArray = function () {
    return (
      Array.isArray(targetClassNames) &&
      targetClassNames.some(targetClassName =>
        classList.contains(targetClassName)
      )
    );
  };
  const matchesClassName = function () {
    return classList.contains(targetClassNames);
  };
  return !!classList && !!(matchesClassNameInArray() || matchesClassName());
};

export const hasAncestorWithClassName = (element, targetClassNames) => {
  if (hasClassName(element, targetClassNames)) {
    return true;
  }
  if (element.parentNode) {
    return hasAncestorWithClassName(element.parentNode, targetClassNames);
  }
  return false;
};

export const removePreloadContainer = () => {
  const preloadContainer = document.querySelector('.ndx-PreloadContainer');
  if (preloadContainer) {
    preloadContainer.parentNode.removeChild(preloadContainer);
  }
};

export function isDisappearingCardToolVisible(element) {
  return element.parent().props().visible;
}

export const revealCiHeaderPlaceholder = () => {
  const ciHeader = document.querySelector('#ci-header-placeholder');
  ciHeader.classList.add('ci-header-visible');
};
